import { PCFRequestStatus } from '../enums/pcf-request';

// Function to expand the "Complete" status to include all related statuses
// Used for Status filters in the table headers
// When selecting "Complete" option, it will also include other statuses in the request body when making the API call
export const expandCompleteStatus = (
  statuses: string[],
  completeStatusMapping: PCFRequestStatus[],
): string[] => {
  const expandedStatuses = [...statuses];
  if (expandedStatuses.includes(PCFRequestStatus.Complete)) {
    // Remove Complete and add all related statuses
    expandedStatuses.splice(expandedStatuses.indexOf(PCFRequestStatus.Complete), 1);
    expandedStatuses.push(...completeStatusMapping);
  }

  return expandedStatuses;
};
